// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4bc2207f","453":"8ff523a2","667":"e43d61ea","977":"3e43583b"}[chunkId] + ".chunk.js";
};